import React from 'react'
import Chip from '../Chip'
import Tooltip from '../Tooltip'
import { ComboBoxOption } from './helper/utils'
import ComboBoxContext from './ComboBoxContext'

const MultipleTags = <T extends ComboBoxOption>() => {
  const {
    classes,
    getChipLabel,
    getOptionDisabled,
    getOptionLabel,
    getOptionValue,
    hideClearOnDisabled,
    limitChips,
    options,
    removeSelectedItem,
    selectedItems,
    setSelectedItems,
  } = React.useContext(ComboBoxContext)

  let result = selectedItems.map((selectedItem, index) => {
    const allowDelete = !(hideClearOnDisabled && getOptionDisabled(selectedItem))
    return (
      <Chip
        key={`${getOptionValue(selectedItem)}${index}`}
        className={classes.chip}
        label={getChipLabel(selectedItem)}
        onDelete={allowDelete ? () => removeSelectedItem(selectedItem) : undefined}
      />
    )
  })

  // limited number of chips
  if (limitChips > -1 && selectedItems && selectedItems.length > limitChips) {
    const limit = limitChips > -1 ? limitChips : 1
    // keeps last selected items depending on limit
    // group other items in a single chip with Tooltip
    const keepCount = limit - 1
    const groupedCount = selectedItems.length - keepCount
    const keepedTags = result.splice(groupedCount, keepCount)
    const keepedItems: T[] = selectedItems.slice(groupedCount)
    const groupedItems: T[] = selectedItems.slice(0, groupedCount)
    const showPlus = limit > 1 && keepCount > 0
    const groupedLabel = `${showPlus ? '+ ' : ''}${groupedItems.length}${showPlus ? '' : ' items'}`
    result = [
      <Tooltip key='tooltip' placement='top' label={groupedItems.map((x: T) => getOptionLabel(x)).join(', ')}>
        <Chip
          className={classes.chip}
          label={options.length === groupedItems.length ? 'All' : groupedLabel}
          onDelete={() => setSelectedItems(keepedItems)}
        />
      </Tooltip>,
      ...keepedTags,
    ]
  }

  return <>{result}</>
}

export default MultipleTags
